import { createGenericTypes, createGenericActions } from 'utils/createAction'

export const addPayoutMethod = createGenericTypes('ADD_PAYMENT_METHOD')
export const addPayoutMethodActions = createGenericActions(addPayoutMethod)

export const getPayoutScheduleTypes = createGenericTypes('GET_PAYOUT_SCHEDULE')
export const getPayoutScheduleActions = createGenericActions(
  getPayoutScheduleTypes
)
